// extracted by mini-css-extract-plugin
export default {"logo":"Topbar_logo__wJDRR","logout":"Topbar_logout__djZUR"};